import { useState } from 'react';
import '../index.css';

import { getOrigin } from '../utils';

export default function Demo() {
  return (
    <div className='live-preview-container'>
      <div className='tour-loading-indicator'>Loading tour...</div>

      <iframe
        width={'100%'}
        height={'100%'}
        src={getOrigin()}
        frameBorder='none'
      ></iframe>
    </div>
  );
}
